exports.components = {
  "component---src-templates-art-art-tsx": () => import("./../../../src/templates/art/art.tsx" /* webpackChunkName: "component---src-templates-art-art-tsx" */),
  "component---src-templates-dir-dir-tsx": () => import("./../../../src/templates/dir/dir.tsx" /* webpackChunkName: "component---src-templates-dir-dir-tsx" */),
  "component---src-templates-home-home-tsx": () => import("./../../../src/templates/home/home.tsx" /* webpackChunkName: "component---src-templates-home-home-tsx" */),
  "component---src-templates-qa-art-qa-art-tsx": () => import("./../../../src/templates/qa-art/qa-art.tsx" /* webpackChunkName: "component---src-templates-qa-art-qa-art-tsx" */)
}

